import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

import { navRootOptions } from 'src/shared/constants/rootNavigation';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

import { ConfirmPage, ConfirmPageParamsModel } from 'src/pages/confirm/confirm.component';
import { Client } from "src/providers/client/client";
import { ActivatedRoute } from '@angular/router';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { SuccessPage } from 'src/shared/pages/success/success';
import { Util } from 'src/shared/util/util';
import { WindowService } from 'src/shared/providers/window.service';
import { DemoBlockService } from 'src/shared/services/demo-block.service';

@Component({
    templateUrl: 'cancellation-options.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class CancellationOptionsPage implements OnInit {

  errorMessage: string;
  title: string;
  cancellingAccount: boolean;
  form: UntypedFormGroup;
  isAccountOwner: boolean;
  cancellationCheckResponse: any;
  cantGoBack: boolean;
  isRightSideContent = true;
  dialogParams: any;


  boundConfirmcancelAllJobs = this.confirmcancelAllJobs.bind(this);
  boundCancelAccount = this.cancelAccount.bind(this);
  boundStopCancellingAccount = this.stopCancellingAccount.bind(this);
  boundConfirmAccountCancellation = this.confirmAccountCancellation.bind(this);

constructor(
    private client: Client,
    private modalController: ModalController,
    private navCtrl: CustomNavController,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private storage: TidyStorage,
    private rightSidePanelService: RightSidePanelService,
    private util: Util,
    private windowService: WindowService,
    private demoBlock: DemoBlockService
  ) {
    this.form = this.fb.group({
      firstCheck: [false, Validators.requiredTrue],
      secondCheck: [false, Validators.requiredTrue],
      thirdCheck: [false, Validators.requiredTrue]
  });
};

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.rightSidePanelService.setDialogPageTitle('Cancellation Options');
    if (this.isRightSideContent) {
      this.dialogParams = await this.storage.retrieve('dialog-params');
    }
    this.errorMessage = '';
    this.cantGoBack = this.route.snapshot.data.cantGoBack;
    this.isAccountOwner = localStorage.getItem('user_role') === 'owner';;
    this.title = 'Cancellation Options';
    this.cancellingAccount = false;
  }

  async confirmcancelAllJobs() {
    if (this.demoBlock.block()) {return;}
    const params: ConfirmPageParamsModel = {
      title: 'Cancel All Jobs?',
      body: 'Are you sure you want to cancel all your current jobs?',
      backText: 'Go Back',
      confirmText: 'Cancel All Jobs',
      confirmAction: this.cancelAllJobs.bind(this)
    };
    const confirmationModal = await this.modalController.create({
      component: ConfirmPage,
      componentProps: params,
      animated: false,
      cssClass: 'confirm-modal'
    });
    await confirmationModal.present();
  }

  async cancelAllJobs() {
    try {
      await this.client.cancelAllCleanings();
      localStorage.setItem('madeUpdateToSchedule', 'true');
      this.util.showSuccess('Jobs cancelled');
      this.modalController.dismiss();
      if (this.windowService.isDesktopRes) {
        this.rightSidePanelService.closeRightSidePanel();
      } else {
        const shouldShowAllToDosPage = localStorage.getItem('shouldShowAllToDosPage') === 'true';
        this.navCtrl.navigateForward(shouldShowAllToDosPage ? 'schedule' : 'schedule-list');
      }
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
      throw err;
    }
  }

  async cancelAccount() {
    this.title = 'Cancel Account Data?';
    this.cancellingAccount = true;
  }

  async confirmAccountCancellation() {
    if (this.demoBlock.block()) {return;}
    this.errorMessage = '';
    if (this.form.invalid) {
      return this.errorMessage = 'Please confirm above that you want to delete all account data.'
    }
    try {
      this.cancellationCheckResponse = await this.client.cancelAccountCheck();
      const cancelStatus = this.cancellationCheckResponse.valid;

      if(cancelStatus){
        await this.client.cancelAccount();
        localStorage.clear();
        this.navCtrl.navigateRoot('login', navRootOptions);
      }else{
        const params = this.mountFailedPageParams();
        this.rightSidePanelService.navigateTo('success', params, SuccessPage);
      }

    } catch(err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  stopCancellingAccount() {
    this.title = 'Cancellation Options';
    this.cancellingAccount = false;
  }

  mountFailedPageParams() {
    const shouldShowAllToDosPage = localStorage.getItem('shouldShowAllToDosPage') === 'true';
    return {
      header: 'Cancellation Failed',
      body: 'You can only do this after all pending charges or credits have been resolved. Please give at least 72 hours after your last transaction to try this.',
      buttonText: 'Ok',
      buttonRoute: shouldShowAllToDosPage || this.windowService.isDesktopRes ? 'schedule' : 'schedule-list'
    };
  }
}
